export const wcApiUrl = (env) => ({
  REACT_APP_TOKEN_SERVICE_URL: `https://api-dt-${env}.orientalbank.com/dsasync/auth/v2/token`,
  REACT_APP_AUTHENTICATED_INITIATEUI: `https://api-dt-${env}.orientalbank.com/dsasync/authenticated/initiateui`,
});

// event to redirect the user from web component to dashboard.
export const handleBacktoAccount = () => {
  window.dispatchEvent(
    new CustomEvent('goto-account', {
      bubbles: true,
      composed: true,
    })
  );
};

export const openLinkOrDownloadWithoutIsSafeUrl = (url, filename) => {
  try {
    if (typeof window !== 'undefined' && window.cordova && window.cordova.InAppBrowser) {
      // Open in system browser to trigger download
      window.cordova.InAppBrowser.open(url, '_system');
      // window.cordova.InAppBrowser.open(`${url}?ts=${Date.now()}`, '_blank', 'location=yes');
    } else if (filename) {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.rel = 'noopener';
      link.target = '_blank';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Fallback for non-Cordova environments
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (e) {
    // Final fallback
    window.location.href = url;
  }
};

export const webComponentBaseUrl = (env) => {
  const baseUrl = `https://ds-ui-assets${env === 'prod' ? `` : `-${env}`}.orientalbank.com`;
  return baseUrl;
};

// utils/popperUtils.js (or utils/wcFlowUtils.js)

/**
 * Resolves the Shadow Root container for MUI Popper components
 * when rendered inside a Web Component (Shadow DOM).
 *
 * Use this with React.useMemo() in any component that renders
 * a MUI Popper (Autocomplete, DatePicker, Select, etc.)
 *
 * @param {boolean} isWcFlow - Whether the app is running as a web component
 * @param {React.RefObject} hostRef - Ref attached to the component inside Shadow DOM
 * @returns {ShadowRoot | undefined} - Shadow root as portal target, or undefined for regular web flow
 */
export const getShadowRootContainer = (isWcFlow, hostRef) => {
  if (!isWcFlow) return undefined;
  const root = hostRef?.current?.getRootNode?.();
  return root instanceof ShadowRoot ? root : undefined;
};
